import { getApiFilterBuilder, getApiPaging, getApiSort } from '../../../utils/apig02/apig02'
import { get, intersection } from 'lodash'
import { mapForBulk } from '../../selectors/participants/mapParticipantsForBulk'
import { sameIdsIn } from '../../../utils/array'

const GET_LEADERS_OVERVIEW = 'dofe-bo/LEADER/GET_LEADERS_OVERVIEW'
const GET_LEADERS_OVERVIEW_SUCCESS = 'dofe-bo/LEADER/GET_LEADERS_OVERVIEW_SUCCESS'
const GET_LEADERS_OVERVIEW_FAIL = 'dofe-bo/LEADER/GET_LEADERS_OVERVIEW_FAIL'

const GET_LEADERS_OVERVIEW_COUNT = 'dofe-bo/LEADER/GET_LEADERS_COUNT_OVERVIEW'
const GET_LEADERS_OVERVIEW_COUNT_SUCCESS = 'dofe-bo/LEADER/GET_LEADERS_OVERVIEW_COUNT_SUCCESS'
const GET_LEADERS_OVERVIEW_COUNT_FAIL = 'dofe-bo/LEADER/GET_LEADERS_OVERVIEW_COUNT_FAIL'

const SET_LEADERS_OVERVIEW_FILTER = 'dofe-bo/LEADER/SET_LEADERS_OVERVIEW_FILTER'
const SET_LEADERS_OVERVIEW_PARAMS = 'dofe-bo/LEADER/SET_LEADERS_OVERVIEW_PARAMS'

const SET_LEADERS_OVERVIEW_SELECTED = 'dofe-bo/LEADER/SET_LEADERS_OVERVIEW_SELECTED'
const TOGGLE_LEADERS_OVERVIEW_ALL_SELECTED = 'dofe-bo/LEADER/TOGGLE_LEADERS_OVERVIEW_ALL_SELECTED'
const BULK_LEADERS_OVERVIEW_RESET = 'dofe-bo/LEADER/BULK_LEADERS_OVERVIEW_RESET'

const initialState = {
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    loading: false,
    loaded: false,
    selectedIds: [],
    bulk: {
      loading: false,
      loaded: false
    }
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case GET_LEADERS_OVERVIEW:
            return {
                ...state,
                loading: true
            }
        case GET_LEADERS_OVERVIEW_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                list: action.result.list
            }
        case GET_LEADERS_OVERVIEW_FAIL:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.error
            }
      case GET_LEADERS_OVERVIEW_COUNT:
        return {
          ...state,
          countLoaded: false,
          countLoading: true
        }
      case GET_LEADERS_OVERVIEW_COUNT_SUCCESS:
        const totalCount = Number(get(action.result, 'totalCount') || 0)
        return {
          ...state,
          countLoading: false,
          countLoaded: true,
          count: totalCount,
          pages:
            Math.ceil(totalCount / state.limit) ||
            state.pages
        }
      case GET_LEADERS_OVERVIEW_COUNT_FAIL:
        return {
          ...state,
          loading: false,
          loaded: false,
          error: action.error
        }
      case SET_LEADERS_OVERVIEW_FILTER:
        return {
          ...state,
          filter: action.filterBy,
          offset: 0,
          invalidate: new Date().getTime()
        }
      case SET_LEADERS_OVERVIEW_PARAMS:
        return {
          ...state,
          limit:
            action.options.limit !== undefined
              ? action.options.limit
              : state.limit,
          offset:
            action.options.offset !== undefined
              ? action.options.offset
              : state.offset,
          filter:
            action.options.filter !== undefined
              ? action.options.filter
              : state.filter,
          sort:
            action.options.sort !== undefined ? action.options.sort : state.sort
        }
      case SET_LEADERS_OVERVIEW_SELECTED:
        return {
          ...state,
          selectedIds: action.bulkType
            ? intersection(action.selectedIds,
              mapForBulk(state.list || [], action.bulkType))
            : action.selectedIds
        }
      case TOGGLE_LEADERS_OVERVIEW_ALL_SELECTED:
        if (sameIdsIn(action.selectedIds, action.selectableIds)) {
          return {
            ...state,
            selectedIds: []
          }
        }

        return {
          ...state,
          selectedIds: [...action.selectableIds]
        }
      case BULK_LEADERS_OVERVIEW_RESET:
        return {
          ...state,
          bulk: {
            loading: false,
            loaded: false
          }
        }
      default:
            return state
    }
}


export function setLeadersOverviewSelected(selectedIds, bulkType) {
  return {
    type: SET_LEADERS_OVERVIEW_SELECTED,
    selectedIds,
    bulkType
  }
}

export function toggleLeadersOverviewAllSelected(selectedIds, selectableIds) {
  return {
    type: TOGGLE_LEADERS_OVERVIEW_ALL_SELECTED,
    selectedIds,
    selectableIds
  }
}

export function bulkLeadersOverviewReset() {
  return {
    type: BULK_LEADERS_OVERVIEW_RESET
  }
}


export function setLeadersOverviewFilter(filterBy) {
  return {
    type: SET_LEADERS_OVERVIEW_FILTER,
    filterBy
  }
}

export function setLeadersOverviewParams(options) {
  return {
    type: SET_LEADERS_OVERVIEW_PARAMS,
    options
  }
}

export function getLeadersOverview(params = {}) {
  return {
    types: [
      GET_LEADERS_OVERVIEW,
      GET_LEADERS_OVERVIEW_SUCCESS,
      GET_LEADERS_OVERVIEW_FAIL
    ],
    promise: client =>
      client.post(
        `apiv2/award-leader/overview/list`, {
          data: {
            source: 'VIEW',
            sort: getApiSort(params.sort),
            filter: buildOverviewFilter(params),
            paging: getApiPaging(params.offset, params.limit),
            options: {
              getRecordList: true,
              getTotalCount: false
            }
          }
        }
      )
  }
}


export function getLeadersOverviewCount(params = {}) {
  return {
    types: [
      GET_LEADERS_OVERVIEW_COUNT,
      GET_LEADERS_OVERVIEW_COUNT_SUCCESS,
      GET_LEADERS_OVERVIEW_COUNT_FAIL
    ],
    promise: client =>
      client.post(
        `apiv2/award-leader/overview/list`, {
          data: {
            source: 'VIEW',
            filter: buildOverviewFilter(params),
            options: {
              getRecordList: false,
              getTotalCount: true
            }
          }
        }
      )
  }
}


function buildOverviewFilter(params) {
  const filterBuilder = getApiFilterBuilder(params.filter)
    .named('search@like', 'search')
    .parse('organization_name@like', 'organizationName')
    .parse('personState@eq', 'state')
    .named('leaderLabel@or', 'leaderLabels', i => i.value ? i.label : null)

  return filterBuilder.build()
}


